import { render, staticRenderFns } from "./TerminationTypeEditor.vue?vue&type=template&id=38e4a8ca&scoped=true"
import script from "./TerminationTypeEditor.vue?vue&type=script&lang=js"
export * from "./TerminationTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4a8ca",
  null
  
)

export default component.exports